import { DasBoardState } from "types/ShiftTracker";
import { ShiftReportsConstants } from "../constants/constants";
import { ReducersInterfaceAction } from "types/Reducers";
import { initialReportState } from "store/initialStates";

export const dasBoardReducer = (
  state = initialReportState,
  action: ReducersInterfaceAction,
): DasBoardState => {
  switch (action.type) {
    case ShiftReportsConstants.SHIFT_REPORT_GET_LIST_PENDING:
    case ShiftReportsConstants.SHIFT_REPORT_DELETE_PENDING:
    case ShiftReportsConstants.SHIFT_REPORT_COMMENT_UPDATE_PENDING:
    case ShiftReportsConstants.SHIFT_REPORT_CREATE_PENDING:
    case ShiftReportsConstants.SHIFT_REPORT_UPDATE_PENDING:
      return {
        ...state,
        reportListLoading: true
      };
    case ShiftReportsConstants.SHIFT_REPORT_GET_LIST_ERROR:
    case ShiftReportsConstants.SHIFT_REPORT_DELETE_ERROR:
    case ShiftReportsConstants.SHIFT_REPORT_COMMENT_UPDATE_ERROR:
    case ShiftReportsConstants.SHIFT_REPORT_CREATE_ERROR:
    case ShiftReportsConstants.SHIFT_REPORT_UPDATE_ERROR:
      return {
        ...state,
        reportListLoading: false,
      };
    case ShiftReportsConstants.SHIFT_REPORT_COMMENT_UPDATE_SUCCESS:
    case ShiftReportsConstants.SHIFT_REPORT_DELETE_SUCCESS:
      return {
        ...state,
        reportListLoading: false,
        reportList: action.payload,
      };
    case ShiftReportsConstants.SHIFT_REPORT_GET_LIST_SUCCESS:
      return {
        ...state,
        reportList: action.payload.results,
        reportListCount: action.payload.count,
        reportListLoading: false,
      };
    case ShiftReportsConstants.SHIFT_REPORT_UPDATE_FILTERS:
      return {
        ...state,
        reportListFilters: action.payload,
      };
    case ShiftReportsConstants.SHIFT_RECORD_RECORD_UPDATE_FILTERS:
      return {
        ...state,
        recordListFilters: action.payload,
      };
    case ShiftReportsConstants.SHIFT_REPORT_CREATE_SUCCESS:
      return {
        ...state,
        reportListLoading: false,
        reportList: [...state.reportList, action.payload],
        currentReportDate: action.payload.report_date,
        currentReportStation: action.payload.station,
        hasSecondDriver: action.payload.has_second_driver,
      };
    case ShiftReportsConstants.SHIFT_RECORD_GET_PENDING:
      return {
        ...state,
        reportListLoading: true,
      };
    case ShiftReportsConstants.SHIFT_RECORD_GET_ERROR:
      return {
        ...state,
        reportListLoading: false,
        ...(action.payload != null && Number(state.currentReportId) !== Number(action.payload)
          ? { currentReportId: Number(action.payload) }
          : {}),
      };
    case ShiftReportsConstants.SHIFT_RECORD_GET_SUCCESS:
      return {
        ...state,
        reportListLoading: false,
        currentReportId: action.payload.id,
        currentReport: action.payload.records,
        currentReportDate: action.payload.report_date,
        currentReportStation: action.payload.station,
        hasSecondDriver: action.payload.has_second_driver,
        currentReportDispatchers: action.payload.dispatchers,
        currentReportSupportDispatchers: action.payload.support_dispatchers,
        currentReportSpecialSupervisor: action.payload.special_supervisor,
        currentReportSupervisor: action.payload.supervisor,
        currentReportLeadDriver: action.payload.lead_driver,
        currentReportFleetCoordinator: action.payload.fleet_coordinator,
        currentReportPerformanceCoordinator: action.payload.performance_coordinator,
        currentWaveStartTimeList: action.payload.wave_start_time,
      };
    case ShiftReportsConstants.SHIFT_REPORT_UPDATE_SUCCESS:
      return {
        ...state,
        hasSecondDriver: action.payload.has_second_driver,
        currentWaveStartTimeList: action.payload.wave_start_time,
        reportListLoading: false,
      };
    case ShiftReportsConstants.SHIFT_RECORD_ADD_ROW_RECORD:
    case ShiftReportsConstants.SHIFT_RECORD_DELETE_RECORD_FIELD:
    case ShiftReportsConstants.SHIFT_RECORD_UPDATE_RECORD_FIELD:
      return {
        ...state,
        currentReport: action.payload,
      };

    default:
      return state;
  }
};
